module.exports = __webpack_public_path__ + "img/solution_block_bg.9f908aed.png";